import { registerApplication, start } from 'single-spa'
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from 'single-spa-layout'
import microfrontendLayout from './microfrontend-layout.html'
import type { LoadApp } from 'single-spa-layout/dist/types/browser/constructApplications'

const cssElements = {
  react: [],
  angular: [],
}

const routes = constructRoutes(microfrontendLayout)
const loadAppWithLogging: LoadApp = async ({ name }) => {
  const app = await System.import(name)
  return {
    ...app,
    bootstrap: async (props) => {
      if (app.bootstrap.cssBootstrap) {
        app.bootstrap.cssBootstrap()
      }
      if (app.bootstrap.reactBootstrap) {
        return app.bootstrap.reactBootstrap(props)
      }
      return app.bootstrap(props)
    },
    mount: async (props) => {
      if (name === 'react-app') {
        // Append CSS elements again if they were previously removed
        cssElements.react.forEach((tag) => {
          if (!document.head.contains(tag)) {
            document.head.appendChild(tag)
          }
        })

        // Track CSS module <style> elements with unique attribute
        const styleElements = Array.from(
          document.querySelectorAll('style[data-react-app-css="true"]')
        )
        styleElements.forEach((style) => {
          if (!cssElements.react.includes(style)) {
            cssElements.react.push(style)
          }
        })

        // Track CSS <link> elements with unique attribute
        // Support MiniCssExtractPlugin used in production
        const linkElements = Array.from(
          document.querySelectorAll('link[data-react-app-css="true"]')
        )
        linkElements.forEach((link) => {
          if (!cssElements.react.includes(link)) {
            cssElements.react.push(link)
          }
        })
      } else if (name === 'learnlux-app') {
        // Append CSS elements again if they were previously removed
        cssElements.angular.forEach((tag) => {
          if (!document.head.contains(tag)) {
            document.head.appendChild(tag)
          }
        })

        // Track CSS module <style> elements with unique attribute
        const styleElements = Array.from(document.querySelectorAll('style'))
        styleElements.forEach((style) => {
          if (style.innerHTML.includes('.unique-angular-tag')) {
            cssElements.angular.push(style)
          }
        })

        // Track CSS <link> elements with unique attribute
        // Support MiniCssExtractPlugin used in production
        const linkElements = Array.from(document.querySelectorAll('link'))
        linkElements.forEach((link) => {
          if (link.innerHTML.includes('.unique-angular-tag')) {
            cssElements.angular.push(link)
          }
        })
      }

      if (app.mount.cssMount) {
        await app.mount.cssMount()
      }
      if (app.mount.reactMount) {
        return app.mount.reactMount(props)
      }
      return app.mount(props)
    },
    unmount: async (props) => {
      if (name === 'react-app') {
        // Remove all tracked CSS elements for React App
        cssElements.react.forEach((tag) => {
          if (document.head.contains(tag)) {
            document.head.removeChild(tag)
          }
        })
      } else if (name === 'learnlux-app') {
        // Remove all tracked CSS elements for Angular App
        cssElements.angular.forEach((tag) => {
          if (document.head.contains(tag)) {
            document.head.removeChild(tag)
          }
        })
      }
      if (app.unmount.cssUnmount) {
        app.unmount.cssUnmount()
      }
      if (app.unmount.reactUnmount) {
        return app.unmount.reactUnmount(props)
      }
      return app.unmount(props)
    },
  }
}

const applications = constructApplications({
  routes,
  loadApp: loadAppWithLogging,
})
const layoutEngine = constructLayoutEngine({ routes, applications })

applications.forEach(registerApplication)
layoutEngine.activate()
start()
